export default "__VITE_ASSET__B6k0U9yE__"